<unity-outside-container modalHeaderTitle="Setup" modalHeaderSubtitle="Account">
  <kendo-stacklayout class="outside-form" orientation="vertical" [gap]="detailCardGridLayoutGap.rows!">
    <h5>An administrator will be in touch soon!</h5>
    <span>Your account is currently in state: {{ $registrationStatus() }}.</span>
    <button kendoButton themeColor="primary" routerLink="/login" type="submit">Back to Login</button>
  </kendo-stacklayout>
</unity-outside-container>
